module.exports = function getResource(label, vars = []) {
    const resources = { minutes: 'min' };

    return resources[label];
};
